import { TTrackEventData, TTrackPageViewData } from '@src/tracking/constant';

export const DASHBOARD_ONBOARDING_STEP_EVENTS = {
  STEP_1: {
    component_name: 'onboarding - track couriers',
    component_type: 'banner',
  },
  STEP_2: {
    component_name: 'onboarding - plan deliveries',
    component_type: 'banner',
  },
  STEP_3: {
    component_name: 'onboarding - control centre',
    component_type: 'banner',
  },
  STEP_4: {
    component_name: 'onboarding - two ways to view',
    component_type: 'banner',
  },
  STEP_5: {
    component_name: 'onboarding - courier progress',
    component_type: 'banner',
  },
  STEP_6: {
    component_name: 'onboarding - see your orders',
    component_type: 'banner',
  },
  PRODUCT_OVERVIEW_LINK: {
    component_name: 'onboarding tutorial - mcap benefits',
    component_type: 'banner',
    banner_action: 'cta - product overview link',
  },
  DIALOG_REVIEW_TUTORIAL: {
    component_name: 'onboarding - mcap benefits',
    component_type: 'banner',
    banner_action: 'cta - review tutoiral',
  },
  DIALOG_FINAL_CLOSE: {
    component_name: 'onboarding - mcap benefits',
    component_type: 'banner',
    banner_action: 'cta - close',
  },
  DIALOG_FINAL_END: {
    component_name: 'onboarding - mcap benefits',
    component_type: 'banner',
    banner_action: 'cta - end tutoiral',
  },
};

export type TStepInitialized = TTrackEventData<{
  banner_action?: string;
  component_action?: string;
}>;
